import api from '../../Axios'; // Adjust this path to point to your configured Axios instance

// 🟢 STEP 5: Save Establishment Proof
// Endpoint: /api/experts/doctor/establishment
export const saveEstablishment = async (formData: FormData) => {
  return api.post('/api/experts/doctor/establishment', formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // Required for file uploads
    },
  });
};